import {Component, Input, OnInit} from '@angular/core';
import {AuthServicesService, JwtService, OauthService} from 'mclane-webauth-lib';
import {ErrorApiService} from '../../test/error-api.service';
import {LoggingService, MenuService} from 'mclane-apptemplate-lib';
import {environment} from '../../../environments/environment';
import {KeycloakServices} from '../../core/authentication/keycloak.service';
import {paths} from '~/app/app-paths';
import {ErrorService} from '~/app/core/services/error.service';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})

export class MenuComponent implements OnInit {

  @Input() customerId: number;
  public x: any;
  private userText = 'Welcome ' + this.Auth.getUsername();
  private username = this.Auth.getUsername();
  private resizeObservable$: any;
  private token: any;
  private roles: string[];
  private GlFlag: boolean = true;
  public userprofile = environment.keycloak.url + '/realms/' + environment.keycloak.realm + '/account/';
  public data: Array<any> = [
    {text: 'Profile'},
    {
      text: 'Logout',
      click: () => {
        this.logoutClicked();
      }
    }
  ];

  home = [
    {text: 'Home', separator: false, icon: '', disabled: false, textColor: 'white', url: 'home', subItems: null}
  ];

  default = [
    {
      text: 'Statements',
      separator: false,
      icon: '',
      disabled: false,
      textColor: 'green',
      url: 'statements',
      subItems: null
    },
    {
      text: 'Invoices',
      separator: false,
      icon: '',
      disabled: false,
      textColor: 'green',
      url: 'invoices',
      subItems: null
    },
  ];

  menutypeAP = [

    {
      text: 'Reports',
      separator: false,
      icon: '',
      disabled: false,
      textColor: 'green',
      url: 'reports',
      subItems: null
    },
    {
      text: 'Setup',
      separator: false,
      icon: '',
      disabled: false,
      textColor: 'white',
      url: '',
      subItems: [
        {
          text: 'Item GL Setup',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'white',
          url: paths.itemGlSetup,
          subItems: null
        },
        {
          text: 'Store AP GL Xref',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'white',
          url: paths.storeApGLXref,
          subItems: null
        },
        {
          text: 'Item Setup',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'white',
          url: paths.itemSetup,
          subItems: null
        },
        {
          text: 'Store Config',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'white',
          url: paths.storeConfig,
          subItems: null
        },
        {
          text: 'Hierarchy',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'white',
          url: paths.hierarchy,
          subItems: null
        },
        {
          text: 'GL Codes Setup Template',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'white',
          url: paths.glCodesSetupTemplate,
          subItems: null
        },
        {
          text: 'Store Report Grouping',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'white',
          url: paths.storeReportGrouping,
          subItems: null
        }
      ]
    },
    {
      text: 'Accounting',
      separator: false,
      icon: '',
      disabled: false,
      textColor: 'green',
      subItems: [
        {
          text: 'Accounts Payable',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'green',
          url: paths.accountspayable,
          subItems: null
        }
      ]
    },
    {
      text: 'User Admin',
      separator: false,
      icon: '',
      disabled: false,
      textColor: 'green',
      url: '',
      subItems: [
        {
          text: 'Report Access',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'green',
          url: paths.reportAccess,
          subItems: null
        },
        {
          text: 'Store Access',
          separator: false,
          icon: '',
          disabled: false,
          textColor: 'green',
          url: paths.storeAccess,
          subItems: null
        }
      ]
    },
    {text: 'Help', prepend: '', separator: false, icon: '', disabled: false, url: 'https://www.mclaneco.com/content/dam/mclane/shared/documents/OI_Help_Training.pdf', subItems: null},
  ];


  menutypeGLGuide = [
    {
      text: 'GL Guide',
      separator: false,
      icon: '',
      disabled: false,
      textColor: 'green',
      url: 'glguidemenu',
      subItems: null
    },
  ];


  // settings = [{
  //   text: this.userText,
  //   separator: false,
  //   icon: 'user',
  //   disabled: false,
  //   textColor: 'green',
  //   expanded: false,
  //   subItems: [
  //     {
  //       text: 'Settings',
  //       separator: false,
  //       icon: 'gear',
  //       disabled: false,
  //       textColor: 'green',
  //       url: 'app-settings',
  //       subItems: null
  //     },
  //     {
  //       text: 'User Profile',
  //       separator: false,
  //       icon: 'user',
  //       disabled: false,
  //       textColor: 'green',
  //       url: this.userprofile,
  //       subItems: null
  //     },
  //     {
  //       text: 'Logout',
  //       separator: false,
  //       icon: 'user',
  //       disabled: false,
  //       textColor: 'green',
  //       url: '',
  //       expanded: false,
  //       subItems: null,
  //       level: 1,
  //       click: () => this.logoutClicked()
  //     }
  //   ]
  // }];


  constructor(public Auth: AuthServicesService,
              private errorApiService: ErrorApiService,
              private errorService: ErrorService,
              private menuService: MenuService,
              public jwt: JwtService, public console: LoggingService, public oauthService: OauthService, public keycloakService: KeycloakServices) {
    this.menuService.eventRan.subscribe((result) => {
      this.ClickedItem(result);
    });
  }

  ngOnInit(): void {
    this.roles = this.jwt.roles;
    this.console.log('ROLES! = ', this.roles);
    let menuArray = [];

    menuArray = menuArray.concat(this.home);
    if (this.roles.includes('Login_User_Default')) {
      menuArray = menuArray.concat(this.default);
    }
    if (this.roles.includes('Login_User_GL')) {
      menuArray = menuArray.concat(this.menutypeGLGuide);
    }
    if (this.roles.includes('AP_Export')) {
      menuArray = menuArray.concat(this.menutypeAP);
    }
    // menuArray = menuArray.concat(this.settings);


    this.menuService.setItems(menuArray, this.username, true);
  }

  Tapped() {
    this.x.text = 'Marcus';
    this.x.disabled = true;
  }

  ClickedItem($event) {
    this.console.log($event);
    switch ($event.text) {
      case 'Logout':
        this.logoutClicked();
        break;
    }
  }


  logoutClicked() {
    this.oauthService.logoutOfApplication('');
  }

  testError() {
    // <app-mcl-button text="401 error" primary="true" (click)="testError()" >
    //   </app-mcl-button>
    // this.errorApiService.test401().catch(this.errorService.handleError('401 error ez'));
    // this.loadingIndicator.show();
    this.errorApiService.testSplunk().then(() => {
    });
  }

  isTestUser() {
    return this.Auth.getUsername().toLocaleUpperCase() === 'HELPDESK';
  }

}
